export default {
    mounted(el) {
        el.addEventListener('click', createRipple);
    },
    unmounted(el) {
        el.removeEventListener('click', createRipple);
    },
};
function createRipple(event) {
    const button = event.currentTarget;
    const circle = document.createElement('span');
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;
    circle.classList.add('ripple');
    circle.style.width = circle.style.height = `${diameter}px`;
    circle.style.left = `${event.clientX - (button.getBoundingClientRect().left + radius)}px`;
    circle.style.top = `${event.clientY - (button.getBoundingClientRect().top + radius)}px`;
    button.classList.add('btn-ripple');
    button.appendChild(circle);
    circle.addEventListener('animationend', () => button.removeChild(circle));
}
